import { AppStoreDialog } from "client/Features/Apps/Store/AppStoreDialog";
import { ReactElement } from "react";

export type AppAccessActivityInvocationProps = {
	onDismiss: () => void;
};

export const AppAccessActivityInvocation = (props: AppAccessActivityInvocationProps): ReactElement => {
	const {
		onDismiss
	} = props;

	return (
		<AppStoreDialog
			onClose={onDismiss}
		/>
	);
};

AppAccessActivityInvocation.displayName = "AppAccessActivityInvocation";